import { useState, useEffect } from "react";
import Popup from "../../Popup";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";
import { navLinks } from "./navLinks";

// Main Navbar Component
const NAVBAR_HEIGHT = 100;

const Navbar = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOverLightSection, setIsOverLightSection] = useState(false);

  useEffect(() => {
    let rafId = null;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        rafId = requestAnimationFrame(() => {
          const scrollPosition = window.scrollY;
          setIsScrolled(scrollPosition > 50);

          // Batch DOM reads using requestAnimationFrame to avoid forced reflows
          const lightSections = document.querySelectorAll(
            '[data-section-theme="light"]',
          );
          const viewportTop = NAVBAR_HEIGHT;
          let overLight = false;
          
          // Read all layout properties in a single batch
          lightSections.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect.top <= viewportTop && rect.bottom >= 0) {
              overLight = true;
            }
          });
          setIsOverLightSection(overLight);
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  return (
    <div className="absolute top-0 left-0 right-0 z-50">
      {/* Desktop Navbar */}
      <div className="hidden xl:block text-center">
        <DesktopNavbar
          navLinks={navLinks}
          onContactClick={togglePopup}
          isScrolled={isScrolled}
          isOverLightSection={isOverLightSection}
        />
      </div>

      {/* Mobile Navbar */}
      <div className="block xl:hidden">
        <MobileNavbar
          navLinks={navLinks}
          onContactClick={togglePopup}
          isScrolled={isScrolled}
          isOverLightSection={isOverLightSection}
        />
      </div>

      {/* Contact Popup */}
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default Navbar;
